import { v4 as uuidv4 } from 'uuid'
import { AJS_ANONYMOUS_ID } from '@shared/constants/segment'
import { type RequestCookies } from '@shared/request_type'
import { logError } from '@/features/shared/utils/logger'

/**
 * returns the anonymous id from the `ajs_anonymous_id` cookie.
 *
 * the cookie is set by `setAnonymousId` in `src/middleware/middlewareImpl.ts`
 * (via `res.cookies.set` on the middleware response). on the pages router,
 * `mergeMiddlewareCookiesOntoReq` copies pending middleware Set-Cookie values
 * onto `req.cookies` before any data fetching code runs, so the cookie is
 * already present here. on the app router, `cookies()` from `next/headers`
 * already reflects the merged middleware cookies.
 */
export function getAnonymousIdOnServer(cookies: RequestCookies): string {
  const anonymousId = cookies[AJS_ANONYMOUS_ID]
  if (anonymousId) return anonymousId

  // if we get this far, our proxy.ts is not setting the cookie, which is a big problem
  logError('Anonymous ID not set! This is likely a bug in proxy.ts')
  // return random id value so as not to break shopping experience
  return uuidv4()
}
